const defaultCampaignProperties = {
    campaignCode: '',
    campaignCodeId: null,
    campaignCodeDescription: null,
    maxFeeCap: null
};

const initialState = {
    ...defaultCampaignProperties,
    campaignCodeChecked: false,
    firstTimeSubscribe: true,
    validCampaign: false,
    timeoutId: null,
    loading: false,
    searching: false,
    campaignCodeValid: false,
    searchingDelayed: false,
    validationError: null,
    searchingDelayedTimeoutId: null,
    isReadOnly: false,
    bannerMobileImageUrl: null,
    bannerTabletImageUrl: null,
    bannerDesktopImageUrl: null,
    hasEnded: false
};

function nullIfFalsy(val) {
    return val ? val : null;
}

function ensureValidCampaignCodeId(campaignCodeId) {
    // Cannot publish when campaignCodeId is zero.
    // Fix server side when Riot SYI is used by 100% of members.
    if (campaignCodeId === 0) {
        return null;
    }
    return nullIfFalsy(campaignCodeId);
}

function validate(state) {
    if (state.campaignCodeChecked) {
        // eslint-disable-next-line better-mutation/no-mutation
        state.validationError = state.campaignCodeValid
            ? null
            : 'syi_campaign_code_invalid';
    } else {
        // eslint-disable-next-line better-mutation/no-mutation
        state.validationError = null;
    }
    return state;
}

export default (state = initialState, action) => {
    switch (action.type) {
        case 'INITIALIZE_CAMPAIGN_CODE_STATE': {
            return validate({
                ...state,
                ...defaultCampaignProperties,
                campaignCode: action.campaignCode,
                campaignCodeId: ensureValidCampaignCodeId(
                    action.campaignCodeId
                ),
                campaignCodeDescription: nullIfFalsy(
                    action.campaignCodeDescription
                ),
                campaignCodeValid:
                    !!action.campaignCodeId || !action.campaignCode,
                campaignCodeChecked: !!action.campaignCode,
                isReadOnly: action.isReadOnly,
                hasEnded: action.hasEnded
            });
        }

        case 'SET_UNVERIFIED_CAMPAIGN_CODE': {
            return validate({
                ...state,
                ...defaultCampaignProperties,
                campaignCode: action.campaignCode,
                campaignCodeId: null,
                campaignCodeDescription: null,
                campaignCodeValid: !action.campaignCode,
                bannerMobileImageUrl: null,
                bannerTabletImageUrl: null,
                bannerDesktopImageUrl: null
            });
        }

        case 'SET_CAMPAIGN_VALIDATION_RESULT': {
            if (state.campaignCode === action.campaignCode) {
                return validate({
                    ...state,
                    ...defaultCampaignProperties,
                    campaignCode: action.campaignCode,
                    campaignCodeId: ensureValidCampaignCodeId(
                        action.campaignCodeId
                    ),
                    campaignCodeDescription: nullIfFalsy(
                        action.campaignCodeDescription
                    ),
                    campaignCodeValid: action.campaignCodeValid,
                    maxFeeCap: nullIfFalsy(action.maxFeeCap),
                    bannerMobileImageUrl: action.bannerMobileImageUrl,
                    bannerTabletImageUrl: action.bannerTabletImageUrl,
                    bannerDesktopImageUrl: action.bannerDesktopImageUrl,
                    hasEnded: action.hasEnded,
                    searching: false,
                    searchingDelayed: false
                });
            }
            break;
        }
        case 'RESET_MAX_FEE_CAP': {
            return validate({ ...state, maxFeeCap: initialState.maxFeeCap });
        }

        case 'RESET_CAMPAIGN_BANNER': {
            return validate({
                ...state,
                bannerMobileImageUrl: initialState.bannerMobileImageUrl,
                bannerTabletImageUrl: action.bannerTabletImageUrl,
                bannerDesktopImageUrl: action.bannerDesktopImageUrl
            });
        }

        case 'TOGGLE_CAMPAIGN_CODE_CHECKBOX': {
            if (action.isChecked) {
                return validate({
                    ...state,
                    campaignCodeChecked: true,
                    searching: false,
                    searchingDelayed: false
                });
            } else {
                return validate({
                    ...state,
                    campaignCodeChecked: false,
                    campaignCode: initialState.campaignCode,
                    campaignCodeId: initialState.campaignCodeId,
                    campaignCodeDescription: null,
                    searching: false,
                    searchingDelayed: false,
                    hasEnded: false
                });
            }
        }

        case 'VALIDATING_CAMPAIGN_CODE_BY_SEARCHING': {
            return validate({ ...state, searching: true });
        }

        case 'SEARCHING_FOR_CAMPAIGN_CODE_IS_DELAYED': {
            return validate({ ...state, searchingDelayed: true });
        }
    }
    return validate(state);
};
